import { useEffect } from 'react';

import canUseDOM from '../util/can-use-dom';

/**
 * Scrolls to top.
 *
 * @param {Array} effectParams
 */
const useScrollToTop = effectParams => {
  useEffect(() => {
    if (canUseDOM) {
      window.scrollTo(0, 0);
    }
  }, effectParams);
};

export default useScrollToTop;
